
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'SkipLinks',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('navigation', ['isOpen']),

    resolvedLinks() {
      const defaults = [
        {
          label: this.$t('accessibility.skiplinks.to_navigation'),
          selector: '#site-nav',
        },
        {
          label: this.$t('accessibility.skiplinks.to_content'),
          selector: '#site-main',
        },
        {
          label: this.$t('accessibility.skiplinks.to_footer'),
          selector: '#site-footer',
        },
      ]
      return this.links && this.links.length ? this.links : defaults
    },
  },
  methods: {
    ...mapMutations('navigation', ['openNav']),

    async onActivate(link) {
      if (!link || !link.selector) return
      const el = document.querySelector(link.selector)
      if (!el) return

      if (link.selector === '#site-nav') {
        if (el.hasChildNodes()) {
          await this.$store.commit('navigation/openNav')

          el.querySelector('button[type="button"]').focus({
            preventScroll: true,
          })
          return
        }
      }

      let addedTabindex = false
      if (!this.isNaturallyFocusable(el)) {
        el.setAttribute('tabindex', '-1')
        addedTabindex = true
      }

      el.focus({ preventScroll: true })
      try {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } catch (e) {
        el.scrollIntoView(true)
      }

      if (addedTabindex) {
        const remove = () => {
          el.removeAttribute('tabindex')
          el.removeEventListener('blur', remove)
        }
        el.addEventListener('blur', remove)
      }
    },
    isNaturallyFocusable(node) {
      if (!(node instanceof HTMLElement)) return false
      const focusableSelectors = [
        'a[href]',
        'area[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'iframe',
        'audio[controls]',
        'video[controls]',
        '[contenteditable]',
        '[tabindex]:not([tabindex="-1"])',
      ]
      return node.matches(focusableSelectors.join(','))
    },
  },
}
